export { default as styled } from './styled';
export type { StyledJSXIntrinsics, Styled } from './styled';
export type { CSSProperties } from '@linaria/core';
export type { StyledMeta } from '@linaria/tags';
